import React, { Component } from 'react';
import { DISPATCH_ID } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import '../../css/dataTables.css';
import $ from 'jquery';
import DynamicTable from './DynamicTable';

class GenericSearchModal extends Component {

    closeModal = async () => {
        const { view, unMountModal = () => { } } = this.props;
        $(`#${view}`).modal('hide');
        unMountModal();
    };

    render() {
        const { title = '', view, headers = [], columns = [], columnDefs = [], enableSearchInTable, getData, onChangeSearch } = this.props;

        return (
            <div
                className="modal fade bd-example-modal-lg"
                id={`${view}`}
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">

                        <div className="modal-header" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title text-white" id="modal-basic-title">
                                {title}
                            </h4>
                            <button
                                type="button"
                                className="close"
                                onClick={this.closeModal}
                                aria-label="Close"
                            >
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="container">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <DynamicTable
                                            headers={headers}
                                            idTable={view + '-Table'}
                                            enableSearchInTable={enableSearchInTable}
                                            onChangeSearch={onChangeSearch}
                                            getData={getData}
                                            columns={columns}
                                            columnDefs={columnDefs}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn botonCerrar text-white"
                                onClick={this.closeModal}
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GenericSearchModal);